<template>
  <CModal
    class="modal__footer-empty"
    title="Decline application"
    centered
    :show="show"
    @update:show="closeModal"
  >
    <p class="text-center">Are you sure you want to decline this application?</p>
    <form action="" method="" @submit.prevent="onDeclineSubmit">
      <CTextarea 
        v-model="declineReason" 
        placeholder="Provide the reason for decline"
        rows="7"
        required
      />
      <button type="submit" class="btn btn-danger float-right">
        Decline
      </button>
    </form>
  </CModal>
</template>
<script>
import { modalStore } from '@/mixins/modalsMixin'
import {
  createCarManagerMixin,
  carManagerStore
} from "@/mixins/carManagerMixin";

export default {
  name: 'TheDeclineCarModal',

  mixins: [
    createCarManagerMixin()
  ],

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    show() {
      this.declineReason = ''
    }
  },

  data: () => ({
    showForm: true,
    declineReason: '',
  }),

  computed: {
    car () {
      return this.$store.getters[`${modalStore.moduleName}/${modalStore.getterTypes.GETTER_MODAL_CONTENTS}`]
    }
  },

  methods: {
    closeModal () {
      this.$store.dispatch(`${modalStore.moduleName}/${modalStore.actionTypes.ACTION_SET_MODAL_CONTENTS}`, null)
      this.$emit('close')
    },

    onSuccess () {
      this.closeModal()
    },

    onDeclineSubmit() {
      this[carManagerStore.actionTypes.ACTION_VERIFY_CAR]({ id: this.car.id, verificationState: 'declined', declineReason: this.declineReason })
      this.onSuccess()
    }
  }
}
</script>
